import React, { Component } from "react";
import { Box, type Theme } from "@mui/material";
import {grey} from "@mui/material/colors";
import Grid from "@mui/material/Grid";
import PageBase from "../site/PageBase";
import Header from "./Header";
import { bizpost } from "../../ajax";
import { ProgressDialog } from "../dialogs";

import Activity from "./Activity";
import Requisition from './Requisition';
import Rating from './Rating';
import Performance from './Performance';
import General from './General';
import ExecutiveDashboard from './ExecutiveDashboard';
import BudgetDashboard from './BudgetDashboard';
import ActivityDashboard from './ActivityDashboard';
import PerformanceDashboard from './PerformanceDashboard';
import VarianceDashboard from './VarianceDashboard';
import OperationsDashboard from './OperationsDashboard';
import ProjectsDashboard from './ProjectsDashboard';
import StaffingDashboard from './StaffingDashboard';
import RequisitionDashboard from './RequisitionDashboard';
import DataQualityDashboard from './DataQualityDashboard';


const s:any = {
  root: {
    flexGrow: 1,
  },
  navigation: {
    fontSize: 15,
    fontWeight: 300,
    color: grey["600"],
    paddingBottom: 15,
    display: "block",
  },
  title: {
    fontSize: 24,
    fontWeight: 300,
    marginBottom: 20,
    color: "white",
  },
  paper: {
    padding: 30,
  },
  clear: {
    clear: "both",
  },
};

//const boards:any = [Activity,Transactions,Performance,Inspection,Compliance,Rating];
// const boardx:any = {main:Activity,update:Transactions,online:Performance,installed:Inspection,missing:Compliance,default:Rating};
const boardx:any = {default:ExecutiveDashboard,main:BudgetDashboard,requisition:Requisition,activity:Activity,performance:Performance,rating:Rating};

class Dashboard extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props: any) {
    super(props);
    const {dd} = this.props.userData || {};
    const {tabs=[]} = dd||{};
    const {meta=[]} = dd||{};
    const bb = tabs.reduce((a:any[],r:any) => {a.push(r.shc);return a;},[]);
    this.state = {
      dd: this.props.userData.dd,
      tabs: tabs,
      meta: meta,
      boards: bb,
      ping: null,
      timer: 30000,
      count: 0,
      recent: 5,
      offset: 0,
      limit: 1000,
      loading: false,
      isFiltered: false,
      tabid: 0,
    };
  }

  startLoading = () => {
    this.setState({ loading: true });
  };

  stopLoading = () => {
    this.setState({ loading: false });
  };

  componentDidMount() {
    const {timer } = this.state;
    var ping = setInterval(this.refresh,timer);
    this.setState({ ping: ping });
  }

  componentWillUnmount() {
    if (this.state.ping) clearInterval(this.state.ping);
  }

  refresh = async() => {
    try {
      const { meta,tabs, timer, count:rcount,recent:rcn,offset:ofs,limit:lim } = this.state;
      const atb = (Array(tabs).length === 0)? 1 : 0;
      const ame = (Array(meta).length === 0)? 1 : 0;
      const baseparams = { s: "security", a: "dashdata", atb,ame,rcn,ofs,lim };
      const response = await bizpost(baseparams);
      //console.log('count:',rcount);
      const {dd} = response;
      const {counter:offset,rccount:recent} = dd;
      const count = rcount+1;
      //console.log('refresh: counter:',offset,', rccount:',recent);
      //console.log('refresh.dd:',dd);
      this.setState({ count,dd,offset,recent });
    } catch (error) {
      console.log("dd error", error);
      this.sessionError(error);
    }
  }

  sessionError(error: any) {
    const { type, name, title, data } = error || {};
    if (type === "error" && name === "fetcherror" && title === "Unauthorised") {
      const { failure, code } = data || {};
      if (failure === true && code === 401) {
        //session expired. reload page.
        //this.props.doRestart('Session Expired. reloading...');
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }
    }
  }

  onFilter = async (data: any) => {
    //console.log('onFilter',data);
    this.startLoading();
    const { start, end } = data;
    const baseparams = { s: "security", a: "dashfilter", sta: start, sto: end };
    const response = await bizpost(baseparams);
    //console.log('onFilter.response',response);
    this.stopLoading();
    this.setState({ dd: response.dd });
  };

  topTen(distrec:any,distmeta:any) {
    let rtn:any = [];
    try{
      //console.log('topten.distmeta',distmeta);
      // order distrec and map keys to topten codes
      const entriesArray = Object.entries(distrec);
      //console.log('topten.entries',entriesArray);
      entriesArray.sort((a:any, b:any) => a[1] - b[1]); 
      //console.log('topten.sorted',entriesArray);
      //const nmeta = {...distmeta};
      const distdata = distmeta.reduce((acc: any[], rec: any, idx: number, arr: any) => {
        const entry = entriesArray[idx]
        //console.log('entry=',idx,entry);
        if(Array.isArray(entry)){
          const vrec = {...rec};
          //console.log('entriesarray.',idx,',name=',entry[0]);
          vrec.value = entry[1];
          vrec.name = entry[0];
          vrec.code = entry[0];
          vrec.title = entry[0];
          acc.push(vrec);
        }
        else {
          //console.log('entry is not an array');
        }
        return acc;
      }, []);
      rtn = distdata;
      
      //console.log('topten',rtn);
    }
    catch(err){
      console.log('error','topTen Failed',err);
    }
    return rtn;
  }

  getDist(data: any) {
    const rtn:any = [];
    try{
      const {meta} = this.state;
      const {distset} = data;
      //console.log('distset',distset);
      //console.log('meta',meta);
      for(let distkey in distset){
        const distrec = distset[distkey];
        let topten = false;
        let distmeta = meta.filter((val:any) => val && val.group === distkey);
        let distdata = [];
        if(distmeta.length === 0){
          //console.log('topten for ',distkey);
          const ttmeta = meta.filter((val:any) => val && val.group === 'topten');
          topten = true;
          distdata = this.topTen(distrec,ttmeta); 
        }
        else{
          //console.log('metadefined for ',distkey);
          distdata = distmeta.reduce((acc: any[], rec: any, idx: number, arr: any) => {
            const vrec = {...rec};
            vrec.value = (distrec === null )? "" : distrec[rec.code];
            acc.push(vrec);
            return acc;
          }, []);
        }
        const meta0 = distmeta[0]||{color:'#757575'};
        const {color} = meta0;
        //console.log('distdata.',distkey,':',distdata);
        rtn.push({name:distkey,data:distdata,title:distkey.toUpperCase(),color,record:distrec,topten});
      }
      //console.log('dist',rtn);
    }
    catch(err){
      console.log('error','getDist Failed',err);
    }
    return rtn;
  }

  getInfo(data: any) {
    //console.log('info.data',data);
    const {meta} = this.state;
    const {info:source} = data;
    const infos = meta.filter((val:any) => val && val.group === "info");
    const info = infos.reduce((acc: any[], rec: any, idx: number, arr: any) => {
      //console.log("info.reduce.rec", rec, "source", source);
      const code = String(rec.code).toLowerCase();
      rec.value = source[code];
      //console.log("info.reduce.rec", rec, "source", source);
      acc.push(rec);
      return acc;
    }, []);
    return info;
  }

  onTabChange = (event: any, value: number) => {
    console.log('tabid:',value);
    this.setState({ tabid: value||0 });
  };

  render() {
    const { userData, theme, classes } = this.props;
    const { bd } = userData;
    const { eni } = bd || {};
    const { count,dd, loading, tabid, tabs, meta, boards:bb } = this.state;
    const tab = tabs[tabid];
    const dashdata = dd || { monthly: [], info: {} };
    const infos = this.getInfo(dashdata);
    const dists = this.getDist(dashdata);
    //console.log('render.tab',tabid,tab);

    const {daily, monthly, recent, mapper, distrib} = dashdata;

    //const Board = boards[tabid] || boards[1];
    const Boardx = boardx[tab?.nam] || boardx['main'];

    return (
      <ExecutiveDashboard />
    );
  }
}

export default Dashboard;
